import { Inline, Text, vars } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import { css } from '@eti/styles';
import type { CabinBaggageTripSummary } from '@eti/schema-types';
import { CheckCircle } from '@phosphor-icons/react';
import { getIncludedBaggageText } from './utils/getIncludedBaggageText';
import isCabinBaggageIncluded from './utils/isCabinBaggageIncluded';

const featureTextStyles = css`
  width: -webkit-fill-available; /* stylelint-disable */
`;

export const iconStyles = css`
  flex-shrink: 0;
`;

interface CabinBaggageFeatureProps {
  cabinBaggageTripSummary: CabinBaggageTripSummary;
}

const CabinBaggageFeature = ({ cabinBaggageTripSummary }: CabinBaggageFeatureProps) => {
  const { t } = useTranslation();
  if (!isCabinBaggageIncluded(cabinBaggageTripSummary, t)) {
    return null;
  }
  const cabinBaggageName =
    cabinBaggageTripSummary.cabinBaggageTravelerDetails[0] &&
    getIncludedBaggageText(
      cabinBaggageTripSummary.cabinBaggageTravelerDetails[0].cabinBaggageDetails!,
      'IbeClient.CabinBaggageIncluded.Label',
      t,
    );
  return (
    <Inline as="li" noWrap role="listitem" spacing={8}>
      <CheckCircle
        className={iconStyles}
        color={vars.colors.signal.positive.foreground}
        size={20}
        weight="fill"
      />
      <Text as="p" className={featureTextStyles}>
        {cabinBaggageName}
      </Text>
    </Inline>
  );
};

export default CabinBaggageFeature;
